import { ChangeEvent } from 'react';
import { useField } from 'formik';
import { getFieldError } from '@/helpers/formHelpers/formHelpers';
import { InputPassword, InputPasswordType } from '../InputPassword/InputPassword';
import { ResponseErrorType } from '@/types/sharedTypes';

type FormikPasswordInputType = Omit<InputPasswordType, 'apiError'> & {
  apiError?: ResponseErrorType;
  isConfirmTicks?: boolean;
};

export const FormikPasswordInput = ({ name, apiError, isConfirmTicks, ...rest }: FormikPasswordInputType) => {
  const [field, meta, { setValue }] = useField(name);

  const { apiError: apiErrorMessage, error } = getFieldError(name, meta, apiError);
  const hasConfirmTicks = isConfirmTicks && field.value?.trim() && !meta.error;

  const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  return (
    <InputPassword
      {...field}
      onChange={onChangeHandler}
      apiError={apiErrorMessage}
      error={error}
      hasConfirmTicks={hasConfirmTicks}
      {...rest}
    />
  );
};
